import { render, staticRenderFns } from "./Culture.vue?vue&type=template&id=585c26f8&scoped=true&"
import script from "./Culture.vue?vue&type=script&lang=js&"
export * from "./Culture.vue?vue&type=script&lang=js&"
import style0 from "./Culture.vue?vue&type=style&index=0&id=585c26f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585c26f8",
  null
  
)

export default component.exports